export const productOptions = {
    aroma: {
        EUCALYPTUS: {
            name: "Eucalyptus",
            image: "Eucalyptus.png"
        },
        EVERGREEN: {
            name: "Evergreen",
            image: "Evergreen.png"
        },
        MINT: {
            name: "Mint",
            image: "Mint.png"
        },
        BREATHE: {
            name: "Breathe",
            image: "Breathe.png"
        },
        LAVENDER: {
            name: "Lavender",
            image: "Lavender.png"
        },
        PACK_5: {
            name: "Essential 5 Pack", // This is hardcoded in a way that is not sustainable. Proper mechanism should be used
            image: "Pack.png"
        },
        PACK_7: {
            name: "Chakra 7 Pack", // This is hardcoded in a way that is not sustainable. Proper mechanism should be used
            image: "Pack.png"
        },
        VITALITY: {
            name: "Vitality",
            image: "Vitality.png"
        }, 
        INVIGORATE: {
            name: "Invigorate",
            image: "Invigorate.png"
        }, 
        AWAKENING: {
            name: "Awakening",
            image: "Awakening.png"
        }, 
        HARMONY: {
            name: "Harmony",
            image: "Harmony.png"
        }, 
        CELESTIAL: {
            name: "Celestial",
            image: "Celestial.png"
        }, 
        MYSTIC: {
            name: "Mystic",
            image: "Mystic.png"
        }, 
        NIRVANA: {
            name: "Nirvana",
            image: "Nirvana.png"
        }
    },
    color: {
        BLACK: {
            name: "Black",
            image: "Matte-Black.png",
            spaFrame: "MatteBlack.png"
        },
        WHITE: {
            name: "White",
            image: "White.png",
            spaFrame: "White.png"
        }
    },
    shape: {
        ROUND: {
            name: "Round",
            image: "Round.png"
        },
        SQUARE: {
            name: "Square",
            image: "Square.png"
        }
    },
    steamHead: {
        LINEAR_STEAMHEAD: {
            name: "Linear SteamHead",
            image: "Linear.png"
        },
        ISTEAM_STEAMHEAD: {
            name: "iSteam SteamHead",
            image: "iSteam.png"
        },
        AIRTEMPO_STEAMHEAD: {
            name: "AirTempo SteamHead",
            image: "AirTempo.png"
        },
        ITEMPO_STEAMHEAD: {
            name: "iTempo SteamHead",
            image: "iTempo.png"
        }
    },
    finish: {
        ANTIQUE_BRASS: {
            name: "Antique Brass",
            image: "Antique-Brass.png",
            spaFrame: "AntiqueBrass.png"
        },
        BRUSHED_BRONZE: {
            name: "Brushed Bronze",
            image: "Brushed-Bronze.png",
            spaFrame: "BrushedBronze.png"
        },
        BRUSHED_NICKEL: {
            name: "Brushed Nickel",
            image: "Brushed-Nickel.png",
            spaFrame: "BrushedNickel.png"
        },
        OIL_RUBBED_BRONZE: {
            name: "Oil Rubbed Bronze",
            image: "Oil-Rubbed-Bronze.png",
            spaFrame: "OilRubbedBronze.png"
        },
        POLISHED_BRASS: {
            name: "Polished Brass",
            image: "Polished-Brass.png",
            spaFrame: "PolishedBrass.png"
        },
        POLISHED_CHROME: {
            name: "Polished Chrome",
            image: "Polished-Chrome.png",
            spaFrame: "PolishedChrome.png"
           
        },
        POLISHED_GOLD: {
            name: "Polished Gold",
            image: "Polished-Gold.png",
            spaFrame: "PolishedGold.png"
        },
        POLISHED_NICKEL: {
            name: "Polished Nickel",
            image: "Polished-Nickel.png",
            spaFrame: "PolishedNickel.png"
        },
        SATIN_NICKEL: {
            name: "Satin Nickel",
            image: "Satin-Nickel.png",
            spaFrame: "SatinNickel.png"
        },
          SATIN_BRASS: {
            name: "Satin Brass",
            image: "Polished-Brass.png",
            spaFrame: "SatinBrass.png"
        },
        STAINLESS_STEEL_BRUSHED: {
            name: "Stainless Steel Brushed",
            image: "Stainless-Steel-Brushed.png",
            spaFrame: "StainlessSteelBrushed.png"
        },
        STAINLESS_STEEL_POLISHED: {
            name: "Stainless Steel Polished",
            image: "Stainless-Steel-Polished.png",
            spaFrame: "StainlessSteelPolished.png"
        },
        MATTE_BLACK: {
            name: "Matte Black",
            image: "Matte-Black.png",
            spaFrame: "MatteBlack.png"
        },
        WHITE: {
            name: "White",
            image: "White.png",
            spaFrame: "White.png"
        },
         BLACK: {
            name: "Black",
            image: "Matte-Black.png",
            spaFrame: "MatteBlack.png"
        },

        POLISHED_ALUMINUM: {
            name: "Polished Aluminum",
            image: "Stainless-Steel-Polished.png",
            spaFrame: "Stainless-Steel-Polished.png"

        },

        SATIN_ALUMINUM: {
            name: "Satin Aluminum",
            image: "Satin-Nickel.png",
            spaFrame: "Satin-Nickel.png"
        },

        RAW: {
            name: "Raw",
            image: "Raw.png",
            spaFrame: "SatinBrass.png"
        }
    },

 


   
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/data/product-options.ts